import styled from "styled-components";

export const Titulo = styled.h1`
    color: #887ED8;
    font-size: 25px;
    text-align: center;
    margin: 30px 10px 10px 10px;
`

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    p {
        margin: 10px 0 0 0;
        padding: 0;
        color: #887ED8;
        font-size: 14px;
    }
`